const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'insurance_content',
    viewClass: require('./view'),
    options: {},
});
